import { ark } from "@ark-ui/react/factory";
import { styled } from "@filadd/phi-plus-styled-system/jsx";
import { button } from "@filadd/phi-plus-styled-system/recipes";
export const Button = styled(ark.button, button);
//# sourceMappingURL=RawButton.js.map